module.exports = __webpack_public_path__ + "img/super_info-social_image.c82adda9.jpeg";